import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

import { store } from '~/store';
import { detectUserApiHost } from '~/utils/common';

import './localization';
import './utils/sentry';

import App from './App';

import './index.scss';

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } });

if (!window.location.origin.includes('localhost')) {
  posthog.init(process.env.PUBLIC_POSTHOG_KEY, {
    api_host: detectUserApiHost(),
    person_profiles: 'identified_only',
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <PostHogProvider client={posthog}>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <BrowserRouter>
          <CookiesProvider>
            <App />
          </CookiesProvider>
        </BrowserRouter>
      </Provider>
    </QueryClientProvider>
  </PostHogProvider>,
);
